import { render } from "./AssistantAdminDashboard.vue?vue&type=template&id=afb2e3c8"
import script from "./AssistantAdminDashboard.vue?vue&type=script&lang=js"
export * from "./AssistantAdminDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__